import _ from 'lodash'

const filterMenuItemsByCondition = items =>
  items.filter(item => !_.has(item, 'condition') || item.condition)

export default filterMenuItemsByCondition
